// removed by extract-text-webpack-plugin
module.exports = {"timeline":"Timeline-module__timeline___1bfd-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Timeline/Timeline.module.sass
// module id = 1052
// module chunks = 0